"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCALIZACAO_CIDADES = exports.LOCALIZACAO_ESTADOS = exports.LOCALIZACAO_BAIRROS = exports.LOCALIZACAO_COMPLEMENTOS = exports.LOCALIZACAO_LOGRADOUROS = exports.LOCALIZACAO_RUAS = void 0;
exports.LOCALIZACAO_RUAS = ['Dois', 'Um', 'Principal', 'São José', 'Onze', 'São Paulo', 'Doze', 'Treze',
    'Santo Antônio', 'Brasil', 'A', 'São Pedro', 'Quinze', 'São João',
    'Quatorze', 'São Francisco', 'Sete de Setembro', 'Dezesseis', 'Quinze de Novembro',
    'Tiradentes', 'Dezessete', 'Vinte', 'Bahia', 'Amazonas', 'Dezoito', 'São Sebastião', 'Paraná', 'Bela Vista', 'Santa Luzia', 'São Jorge',
    'Castro Alves', 'Duque de Caxias', 'Projetada', 'Rui Barbosa', 'Santa Catarina', 'Minas Gerais', 'Santos Dumont',
    'Espírito Santo', 'Vinte e Um', 'Vinte e Dois', 'da Paz', 'Treze de Maio', 'Rio de Janeiro',
    'Goiás', 'Ceará', 'Belo Horizonte', 'das Flores', 'Sergipe', 'Vitória', 'José Bonifácio',
    'Pernambuco', 'Piauí', 'Vinte e Três', 'Mato Grosso', 'Santa Maria', 'Dom Pedro II',
    'Primeiro de Maio', 'Pará', 'Maranhão', 'Alagoas', 'Boa Vista', 'São Luiz', 'Vinte e Quatro', 'Paraíba', 'Santa Rita'];
exports.LOCALIZACAO_LOGRADOUROS = ['Avenida', 'Rua', 'Marginal'];
exports.LOCALIZACAO_COMPLEMENTOS = ["Apartamento", 'Aeroporto', 'Anexo', "Andar", "Bloco", "Conjunto", 'Cobertura', "Casa", 'Fazenda', 'Fundos', 'Galeria', "Galp\u00E3o", "Lote", "Loja", "Port\u00E3o", "Quadra", "Sala", "Sobreloja", 'Subsolo', 'Terreo'];
exports.LOCALIZACAO_BAIRROS = ['Centro', 'Bela Vista', 'São José', 'Santo Antônio', 'São Francisco', 'Vila Nova',
    'Boa Vista', 'Industrial', 'São Cristóvão', 'Planalto'];
exports.LOCALIZACAO_ESTADOS = [
    { "nome": "Acre", "uf": "AC" },
    { "nome": "Alagoas", "uf": "AL" },
    { "nome": "Amapá", "uf": "AP" },
    { "nome": "Amazonas", "uf": "AM" },
    { "nome": "Bahia", "uf": "BA" },
    { "nome": "Ceará", "uf": "CE" },
    { "nome": "Distrito Federal", "uf": "DF" },
    { "nome": "Espírito Santo", "uf": "ES" },
    { "nome": "Goiás", "uf": "GO" },
    { "nome": "Maranhão", "uf": "MA" },
    { "nome": "Mato Grosso", "uf": "MT" },
    { "nome": "Mato Grosso do Sul", "uf": "MS" },
    { "nome": "Minas Gerais", "uf": "MG" },
    { "nome": "Pará", "uf": "PA" },
    { "nome": "Paraíba", "uf": "PB" },
    { "nome": "Paraná", "uf": "PR" },
    { "nome": "Pernambuco", "uf": "PE" },
    { "nome": "Piauí", "uf": "PI" },
    { "nome": "Rio de Janeiro", "uf": "RJ" },
    { "nome": "Rio Grande do Norte", "uf": "RN" },
    { "nome": "Rio Grande do Sul", "uf": "RS" },
    { "nome": "Rondônia", "uf": "RO" },
    { "nome": "Roraima", "uf": "RR" },
    { "nome": "Santa Catarina", "uf": "SC" },
    { "nome": "São Paulo", "uf": "SP" },
    { "nome": "Sergipe", "uf": "SE" },
    { "nome": "Tocantins", "uf": "TO" }
];
exports.LOCALIZACAO_CIDADES = [
    ['São Paulo', 'São Paulo'],
    ['Rio de Janeiro', 'Rio de Janeiro'],
    ['Brasília', 'Distrito Federal'],
    ['Salvador', 'Bahia'],
    ['Fortaleza', 'Ceará'],
    ['Belo Horizonte', 'Minas Gerais'],
    ['Manaus', 'Amazonas'],
    ['Curitiba', 'Paraná'],
    ['Recife', 'Pernambuco'],
    ['Goiânia', 'Goiás'],
    ['Belém', 'Pará'],
    ['Porto Alegre', 'Rio Grande do Sul'],
    ['Guarulhos', 'São Paulo'],
    ['Campinas', 'São Paulo'],
    ['São Luís', 'Maranhão'],
    ['São Gonçalo', 'Rio de Janeiro'],
    ['Maceió', 'Alagoas'],
    ['Duque de Caxias', 'Rio de Janeiro'],
    ['Cuiabá', 'Mato Grosso'],
    ['Campo Grande', 'Mato Grosso do Sul'],
    ['Natal', 'Rio Grande do Norte'],
    ['Teresina', 'Piauí'],
    ['São Bernardo do Campo', 'São Paulo'],
    ['Nova Iguaçu', 'Rio de Janeiro'],
    ['João Pessoa', 'Paraíba'],
    ['São José dos Campos', 'São Paulo'],
    ['Santo André', 'São Paulo'],
    ['Ribeirão Preto', 'São Paulo'],
    ['Jaboatão dos Guararapes', 'Pernambuco'],
    ['Osasco', 'São Paulo'],
    ['Uberlândia', 'Minas Gerais'],
    ['Sorocaba', 'São Paulo'],
    ['Contagem', 'Minas Gerais'],
    ['Aracaju', 'Sergipe'],
    ['Feira de Santana', 'Bahia'],
    ['Cuiabá', 'Mato Grosso'],
    ['Joinville', 'Santa Catarina'],
    ['Aparecida de Goiânia', 'Goiás'],
    ['Londrina', 'Paraná'],
    ['Juiz de Fora', 'Minas Gerais'],
    ['Ananindeua', 'Pará'],
    ['Porto Velho', 'Rondônia'],
    ['Serra', 'Espírito Santo'],
    ['Niterói', 'Rio de Janeiro'],
    ['Belford Roxo', 'Rio de Janeiro'],
    ['Caxias do Sul', 'Rio Grande do Sul'],
    ['Campos dos Goytacazes Campos dos Goytacazes', 'Rio de Janeiro'],
    ['Macapá', 'Amapá'],
    ['Florianópolis', 'Santa Catarina'],
    ['Vila Velha', 'Espírito Santo'],
    ['Mauá', 'São Paulo'],
    ['São João de Meriti', 'Rio de Janeiro'],
    ['São José do Rio Preto', 'São Paulo'],
    ['Mogi das Cruzes', 'São Paulo'],
    ['Betim', 'Minas Gerais'],
    ['Santos', 'São Paulo'],
    ['Diadema', 'São Paulo'],
    ['Maringá', 'Paraná'],
    ['Jundiaí', 'São Paulo'],
    ['Campina Grande', 'Paraíba'],
    ['Montes Claros', 'Minas Gerais'],
    ['Rio Branco', 'Acre'],
    ['Piracicaba', 'São Paulo'],
    ['Carapicuíba', 'São Paulo'],
    ['Boa Vista', 'Roraima'],
    ['Olinda', 'Pernambuco'],
    ['Anápolis', 'Goiás'],
    ['Cariacica', 'Espírito Santo'],
    ['Bauru', 'São Paulo'],
    ['Itaquaquecetuba', 'São Paulo'],
    ['São Vicente', 'São Paulo'],
    ['Vitória', 'Espírito Santo'],
    ['Caucaia', 'Ceará'],
    ['Caruaru', 'Pernambuco'],
    ['Blumenau', 'Santa Catarina'],
    ['Franca', 'São Paulo'],
    ['Ponta Grossa', 'Paraná'],
    ['Petrolina', 'Pernambuco'],
    ['Canoas', 'Rio Grande do Sul'],
    ['Pelotas', 'Rio Grande do Sul'],
    ['Vitória da Conquista', 'Bahia'],
    ['Ribeirão das Neves', 'Minas Gerais'],
    ['Uberaba', 'Minas Gerais'],
    ['Paulista', 'Pernambuco'],
    ['Cascavel', 'Paraná'],
    ['Praia Grande', 'São Paulo'],
    ['São José dos Pinhais', 'Paraná'],
    ['Guarujá', 'São Paulo'],
    ['Taubaté', 'São Paulo'],
    ['Petrópolis', 'Rio de Janeiro'],
    ['Limeira', 'São Paulo'],
    ['Santarém', 'Pará'],
    ['Camaçari', 'Bahia'],
    ['Palmas', 'Tocantins'],
    ['Suzano', 'São Paulo'],
    ['Mossoró', 'Rio Grande do Norte'],
    ['Taboão da Serra', 'São Paulo'],
    ['Várzea Grande', 'Mato Grosso'],
    ['Sumaré', 'São Paulo'],
    ['Santa Maria', 'Rio Grande do Sul'],
    ['Gravataí', 'Rio Grande do Sul'],
    ['Governador Valadares', 'Minas Gerais'],
    ['Marabá', 'Pará'],
    ['Juazeiro do Norte', 'Ceará'],
    ['Barueri', 'São Paulo'],
    ['Embu das Artes', 'São Paulo'],
    ['Volta Redonda', 'Rio de Janeiro'],
    ['Ipatinga', 'Minas Gerais'],
    ['Parnamirim', 'Rio Grande do Norte'],
    ['Imperatriz', 'Maranhão'],
    ['Foz do Iguaçu', 'Paraná'],
    ['Macaé', 'Rio de Janeiro'],
    ['Viamão', 'Rio Grande do Sul'],
    ['São Carlos', 'São Paulo'],
    ['Indaiatuba', 'São Paulo'],
    ['Cotia', 'São Paulo'],
    ['Novo Hamburgo', 'Rio Grande do Sul'],
    ['São José', 'Santa Catarina'],
    ['Magé', 'Rio de Janeiro'],
    ['Colombo', 'Paraná'],
    ['Itaboraí', 'Rio de Janeiro'],
    ['Sete Lagoas', 'Minas Gerais'],
    ['Americana', 'São Paulo'],
    ['Marília', 'São Paulo'],
    ['Divinópolis', 'Minas Gerais'],
    ['Itapevi', 'São Paulo'],
    ['São Leopoldo', 'Rio Grande do Sul'],
    ['Araraquara', 'São Paulo'],
    ['Rio Verde', 'Goiás'],
    ['Jacareí', 'São Paulo'],
    ['Rondonópolis', 'Mato Grosso'],
    ['Arapiraca', 'Alagoas'],
    ['Hortolândia', 'São Paulo'],
    ['Presidente Prudente', 'São Paulo'],
    ['Maracanaú', 'Ceará'],
    ['Dourados', 'Mato Grosso do Sul'],
    ['Chapecó Chapecó', 'Santa Catarina'],
    ['Cabo Frio', 'Rio de Janeiro'],
    ['Itajaí', 'Santa Catarina'],
    ['Santa Luzia', 'Minas Gerais'],
    ['Juazeiro', 'Bahia'],
    ['Criciúma', 'Santa Catarina'],
    ['Itabuna', 'Bahia'],
    ['Águas Lindas de Goiás', 'Goiás'],
    ['Rio Grande', 'Rio Grande do Sul'],
    ['Alvorada', 'Rio Grande do Sul'],
    ['Cachoeiro de Itapemirim', 'Espírito Santo'],
    ['Sobral', 'Ceará'],
    ['Luziânia', 'Goiás'],
    ['Parauapebas', 'Pará'],
    ['Cabo de Santo Agostinho', 'Pernambuco'],
    ['Rio Claro', 'São Paulo'],
    ['Angra dos Reis', 'Rio de Janeiro'],
    ['Passo Fundo', 'Rio Grande do Sul'],
    ['Castanhal', 'Pará'],
    ['Lauro de Freitas', 'Bahia'],
    ['Araçatuba', 'São Paulo'],
    ['Ferraz de Vasconcelos', 'São Paulo'],
    ['Santa Bárbara do Oeste', 'São Paulo'],
    ['Nova Friburgo', 'Rio de Janeiro'],
    ['Barra Mansa', 'Rio de Janeiro'],
    ['Nossa Senhora do Socorro', 'Sergipe'],
    ['Teresópolis', 'Rio de Janeiro'],
    ['Guarapuava', 'Paraná'],
    ['Araguaína', 'Tocantins'],
    ['Ibirité', 'Minas Gerais'],
    ['Jaraguá do Sul', 'Santa Catarina'],
    ['São José de Ribamar', 'Maranhão'],
    ['Mesquita', 'Rio de Janeiro'],
    ['Francisco Morato', 'São Paulo'],
    ['Itapecerica da Serra', 'São Paulo'],
    ['Itu', 'São Paulo'],
    ['Linhares', 'Espírito Santo'],
    ['Palhoça', 'Santa Catarina'],
    ['Timon', 'Maranhão'],
    ['Bragança Paulista', 'São Paulo'],
    ['Valparaíso de Goiás', 'Goiás'],
    ['Pindamonhangaba', 'São Paulo'],
    ['Poços de Caldas', 'Minas Gerais'],
    ['Caxias', 'Maranhão'],
    ['Itapetininga', 'São Paulo'],
    ['Nilópolis', 'Rio de Janeiro'],
    ['Ilhéus', 'Bahia'],
    ['Maricá', 'Rio de Janeiro'],
    ['São Caetano do Sul', 'São Paulo'],
    ['Teixeira de Freitas', 'Bahia'],
    ['Camaragibe', 'Pernambuco'],
    ['Abaetetuba', 'Pará'],
    ['Lages', 'Santa Catarina'],
    ['Jequié', 'Bahia'],
    ['Barreiras', 'Bahia'],
    ['Paranaguá', 'Paraná'],
    ['Franco da Rocha', 'São Paulo'],
    ['Parnaíba', 'Piauí'],
    ['Patos de Minas', 'Minas Gerais'],
    ['Mogi Guaçu', 'São Paulo'],
    ['Alagoinhas', 'Bahia'],
    ['Pouso Alegre', 'Minas Gerais'],
    ['Rio das Ostras', 'Rio de Janeiro'],
    ['Queimados', 'Rio de Janeiro'],
    ['Jaú', 'São Paulo'],
    ['Porto Seguro', 'Bahia'],
    ['Botucatu', 'São Paulo'],
    ['Araucária', 'Paraná'],
    ['Sinop', 'Mato Grosso'],
    ['Atibaia', 'São Paulo'],
    ['Balneário Camboriú', 'Santa Catarina'],
    ['Sapucaia do Sul', 'Rio Grande do Sul'],
    ['Toledo', 'Paraná'],
    ['Teófilo Otoni', 'Minas Gerais'],
    ['Garanhuns', 'Pernambuco'],
    ['Santana de Parnaíba', 'São Paulo'],
    ['Vitória de Santo Antão', 'Pernambuco'],
    ['Cametá', 'Pará'],
    ['Barbacena', 'Minas Gerais'],
    ['Santa Rita', 'Paraíba'],
    ['Sabará', 'Minas Gerais'],
    ['Varginha', 'Minas Gerais'],
    ['Apucarana', 'Paraná'],
    ['Brusque', 'Santa Catarina'],
    ['Simões Filho', 'Bahia'],
    ['Araras', 'São Paulo'],
    ['Itaguaí', 'Rio de Janeiro'],
    ['Araruama', 'Rio de Janeiro'],
    ['Pinhais', 'Paraná'],
    ['Crato', 'Ceará'],
    ['Campo Largo', 'Paraná'],
    ['Marituba', 'Pará'],
    ['Resende', 'Rio de Janeiro'],
    ['Cubatão', 'São Paulo'],
    ['São Mateus', 'Espírito Santo'],
    ['Santa Cruz do Sul', 'Rio Grande do Sul'],
    ['Cachoeirinha', 'Rio Grande do Sul'],
    ['Itapipoca', 'Ceará'],
    ['Valinhos', 'São Paulo'],
    ['Maranguape', 'Ceará'],
    ['Ji-Paraná', 'Rondônia'],
    ['Conselheiro Lafaiete', 'Minas Gerais'],
    ['São Félix do Xingu', 'Pará'],
    ['Bragança', 'Pará'],
    ['Vespasiano', 'Minas Gerais'],
    ['Trindade', 'Goiás'],
    ['Uruguaiana', 'Rio Grande do Sul'],
    ['Sertãozinho', 'São Paulo'],
    ['Jandira', 'São Paulo'],
    ['Guarapari', 'Espírito Santo'],
    ['Barcarena', 'Pará'],
    ['Birigui', 'São Paulo'],
    ['Ribeirão Pires', 'São Paulo'],
    ['Arapongas', 'Paraná'],
    ['Codó', 'Maranhão'],
    ['Colatina', 'Espírito Santo'],
    ['Votorantim', 'São Paulo'],
    ['Paço do Lumiar', 'Maranhão'],
    ['Barretos', 'São Paulo'],
    ['Catanduva', 'São Paulo'],
    ['Várzea Paulista', 'São Paulo'],
    ['Guaratinguetá', 'São Paulo'],
    ['Tatuí', 'São Paulo'],
    ['Formosa', 'Goiás'],
    ['Caraguatatuba', 'São Paulo'],
    ['Três Lagoas', 'Mato Grosso do Sul'],
    ['Santana', 'Amapá'],
    ['Bagé', 'Rio Grande do Sul'],
    ['Itatiba', 'São Paulo'],
    ['Bento Gonçalves', 'Rio Grande do Sul'],
    ['Itabira', 'Minas Gerais'],
    ['Salto', 'São Paulo'],
    ['Almirante Tamandaré', 'Paraná'],
    ['Paulo Afonso', 'Bahia'],
    ['Poá', 'São Paulo'],
    ['Araguari', 'Minas Gerais'],
    ['Igarassu', 'Pernambuco'],
    ['Novo Gama', 'Goiás'],
    ['Ubá', 'Minas Gerais'],
    ['Senador Canedo', 'Goiás'],
    ['Passos', 'Minas Gerais'],
    ['Altamira', 'Pará'],
    ['Parintins', 'Amazonas'],
    ['Tucuruí', 'Pará'],
    ['Ourinhos', 'São Paulo'],
    ['Eunápolis', 'Bahia'],
    ['São Lourenço da Mata', 'Pernambuco'],
    ['Paragominas', 'Pará'],
    ['Piraquara', 'Paraná'],
    ['Açailândia', 'Maranhão'],
    ['Umuarama', 'Paraná'],
    ['Corumbá', 'Mato Grosso do Sul'],
    ['Coronel Fabriciano', 'Minas Gerais'],
    ['Paulínia', 'São Paulo'],
    ['Catalão', 'Goiás'],
    ['Muriaé', 'Minas Gerais'],
    ['Santa Cruz do Capibaribe', 'Pernambuco'],
    ['Ariquemes', 'Rondônia'],
    ['Patos', 'Paraíba'],
    ['Cambé', 'Paraná'],
    ['Tailândia', 'Pará'],
    ['Araxá', 'Minas Gerais'],
    ['Erechim', 'Rio Grande do Sul'],
    ['Tubarão', 'Santa Catarina'],
    ['Bacabal', 'Maranhão'],
    ['Japeri', 'Rio de Janeiro'],
    ['Itumbiara', 'Goiás'],
    ['Ituiutaba', 'Minas Gerais'],
    ['São Pedro da Aldeia', 'Rio de Janeiro'],
    ['Lagarto', 'Sergipe'],
    ['Assis', 'São Paulo'],
    ['Lavras', 'Minas Gerais'],
    ['Tangará da Serra', 'Mato Grosso'],
    ['Leme', 'São Paulo'],
    ['Itaperuna', 'Rio de Janeiro'],
    ['Breves', 'Pará'],
    ['Nova Serrana', 'Minas Gerais'],
    ['Iguatu', 'Ceará'],
    ['São Gonçalo do Amarante', 'Rio Grande do Norte'],
    ['Itanhaém', 'São Paulo'],
    ['Santo Antônio de Jesus', 'Bahia'],
    ['Caieiras', 'São Paulo'],
    ['Itacoatiara', 'Amazonas'],
    ['Itaituba', 'Pará'],
    ['Aracruz', 'Espírito Santo'],
    ['Jataí', 'Goiás'],
    ['Barra do Piraí', 'Rio de Janeiro'],
    ['Fazenda Rio Grande', 'Paraná'],
    ['Mairiporã', 'São Paulo']
];
//# sourceMappingURL=name.js.map